import React from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-query";

import { fetchMarques } from 'utils/queries';


import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';


const MarquesSelect = ({ name, value, onChange, fournisseurId }) => {


    const marquesQuery = useQuery(
        ["Marques_FournisseurId", { fournisseurId }],
        () => fetchMarques({ fournisseurId }),
        {}
    );



    const handleChange = (selection) => {
        let marque = marquesQuery.data.find(x => x.id === selection);
        onChange({ target: { name: name, value: { ...marque } } });
    };

    if (marquesQuery.isLoading) {
        return (<p>Chargement en cours</p>);
    }

    if (marquesQuery.error) {
        return (<p>Erreur du chargement des marques, veuillez contacter le support.</p>);
    }


    if (!marquesQuery.data) {
        return (<p>Pas de marques pour ce fournisseur, merci de le signaler au support.</p>);
    }

    //console.log("Marques data=", marquesQuery.data);

    return (
        <>
            <TextField style={{ paddingBottom: '8px' }}
                fullWidth
                variant="outlined"
                InputLabelProps={{
                    shrink: true
                }}

                label={"Marque"}
                required
                select

                name={name}
                value={value.id}
                onChange={e => { handleChange(e.target.value); }}
            >


                {marquesQuery.data.map(marque => {
                    return (
                        <MenuItem key={marque.id} value={marque.id}>
                            {marque.nom}
                        </MenuItem>
                    );
                })}



            </TextField>

        </>
    );

}


MarquesSelect.propTypes = {
    fournisseurId: PropTypes.number,
};


export default MarquesSelect;